import MDinput from '@/components/MDinput';
import Select from '@/components/DSE/Select';
import AddressInput from '@/components/DSE/AddressInput';
import CrudContactPerson from '../components/CrudContactPerson';
import CrudStore from '../components/CrudStore';
import {
  validatorConditionalRequired,
  validatorEmail,
  validatorRequire,
  validatorRequireNumber
} from '@/utils/validators';

export function getFormDefinition(vue) {
  return {
    type: 'tab',
    saveButtons: [true, false, false], // Page, tab 1, tab 2, ...
    showFormLabels: [true, false], // Tab 1, tab 2, ....
    labels: ['domain.tabGeneral', 'domain.tabContactPersons', 'domain.stores'],
    headerTemplate: (str, form) => `
    <h3>
    ${form.name || ''}
    </h3>
    `,
    groups: [
      {
        name: {
          type: MDinput,
          defaultValue: '',
          props: {
            maxlength: 64,
            required: true
          },
          rules: [
            {
              validator: validatorRequire
            }
          ]
        },
        domainID: {
          type: Select,
          defaultValue: vue.$store.getters['domain/getDefaultSelectValueDomainID'],
          props: {
            caption: 'common.domain',
            required: true,
            valueField: 'id',
            labelField: 'name',
            options: vue.$store.getters.domains
          },
          rules: [{ validator: validatorRequireNumber }]
        },
        debtorNumber: {
          type: MDinput,
          defaultValue: '',
          props: {
            caption: 'common.debtorNumber',
            maxlength: 18
          }
        },
        cultureID: {
          type: Select,
          props: {
            caption: 'domain.culture',
            valueField: 'id',
            labelField: 'description',
            loading: vue.$store.getters['culture/isLoading']
          },
          dynamicProps: form => {
            return {
              options: vue.$store.getters['culture/loadedItems'].filter(c => c.domainID === form.domainID)
            };
          }
        },
        nameOnTicket: {
          type: MDinput,
          defaultValue: '',
          props: {
            caption: 'domain.nameOnTicket',
            maxlength: 18
          }
        },
        nameOnInvoice: {
          type: MDinput,
          defaultValue: '',
          props: {
            caption: 'domain.invoiceName',
            maxlength: 64,
            required: true
          },
          rules: [
            {
              validator: validatorRequire
            }
          ]
        },
        companyAddress: {
          type: AddressInput,
          defaultValue: null,
          props: {
            countries: vue.$store.getters['country/loadedItems'],
            countriesLoading: vue.$store.getters['country/isLoading']
          }
        },
        mailingAddress: {
          type: AddressInput,
          defaultValue: null,
          props: {
            countries: vue.$store.getters['country/loadedItems'],
            countriesLoading: vue.$store.getters['country/isLoading']
          }
        },
        companyEmail: {
          type: MDinput,
          props: {
            type: 'email',
            maxlength: 64
          },
          rules: [{ validator: validatorEmail }]
        },
        phone: {
          type: MDinput,
          props: {
            type: 'tel'
          }
        },
        billingAddress: {
          type: AddressInput,
          defaultValue: null,
          props: {
            countries: vue.$store.getters['country/loadedItems'],
            countriesLoading: vue.$store.getters['country/isLoading']
          }
        },
        billingEmail: {
          type: MDinput,
          props: {
            type: 'email',
            maxlength: 64
          },
          rules: [{ validator: validatorEmail }]
        },
        globalLocationNumber: {
          type: MDinput,
          defaultValue: null,
          props: {
            maxlength: 13
          }
        },
        shipperNumber: {
          type: MDinput,
          props: {
            maxlength: 6,
            required: true,
            caption: 'transport.shipperNumber'
          }
        },
        shipperNumberHomeDelivery: {
          type: MDinput,
          props: {
            maxlength: 6,
            required: true,
            caption: 'transport.shipperNumberHomeDelivery'
          }
        },
        vatTypeID: {
          type: Select,
          defaultValue: null,
          props: {
            caption: 'vat.vatType',
            required: true,
            valueField: 'id',
            labelField: 'name',
            loading: vue.$store.getters['vatType/isLoading'],
            options: vue.$store.getters['vatType/loadedItems'].map(e => {
              const option = vue.$store.getters['option/loadedOptions']('vatType').find(
                item => item.code === e.vatTypeOption
              );
              return { id: e.id, name: option.description };
            })
          }
        },
        vatNumber: {
          type: MDinput,
          props: {
            maxlength: 32,
            required: true,
            caption: 'vat.vatNumber'
          },
          dynamicRules: form => [{ validator: validatorConditionalRequired(vue.vatNumberIsRequired(form.vatTypeID)) }]
        },
        consumerOrderTicketURL: {
          type: MDinput,
          props: {
            maxlength: 128,
            caption: 'store.consumerOrderTicketURL'
          }
        }
      },
      // Tab Contact persons
      {
        contactPersons: {
          type: CrudContactPerson,
          defaultValue: [],
          props: {
            caption: 'common.emptyString',
            openInFullscreen: false,
            parentIdFilterField: 'clientID',
            permissionCode: 'Client'
          }
        }
      },
      // Tab Stores
      {
        stores: {
          type: CrudStore,
          defaultValue: [],
          props: {
            tabbed: true,
            caption: 'common.emptyString',
            openInFullscreen: false,
            parentIdFilterField: 'clientID',
            permissionCode: 'Client',
            domainID: vue.domainID
          }
        }
      }
    ]
  };
}

const layoutTabGeneral = {
  named: true,
  sections: [
    {
      width: 50,
      fields: [
        'name',
        'domainID',
        'debtorNumber',
        'nameOnTicket',
        'nameOnInvoice',
        'companyAddress',
        'phone',
        'companyEmail',
        'shipperNumber',
        'shipperNumberHomeDelivery',
        'vatTypeID',
        'vatNumber',
        'cultureID',
        'consumerOrderTicketURL'
      ]
    },
    {
      width: 50,
      fields: ['mailingAddress', 'billingAddress', 'billingEmail', 'globalLocationNumber']
    }
  ]
};
const layoutFullWidth = {
  sections: [
    {
      width: 100
    }
  ]
};

export function getCreateLayoutDefinition(vue) {
  return {
    groups: [layoutTabGeneral]
  };
}
export function getEditLayoutDefinition(vue) {
  return {
    groups: [layoutTabGeneral, layoutFullWidth, layoutFullWidth]
  };
}

export function createItemFromFormData(vue, form) {
  return form;
}

export function createFormDataFromItem(vue, item) {
  vue.domainID = item.domainID;
  return item;
}
